// extracted by mini-css-extract-plugin
export default {"info-text":"Y3kB7c8zBDmoNsUPcapQ","bullet":"UiBvZSd7IROn6hhlDJiV"};